// RepositoryError wraps axios errors when handled,
// making it easier to omit special handling for handled errors.
export class RepositoryError extends Error {
  constructor(message, error) {
    super(message);
    this.name = "RepositoryError";
    this.error = error;
  }

  /**
   * unwrap returns the wrapped error.
   */
  unwrap() {
    return this.error;
  }
}
